import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { formatMoney, getAmountCollectedToday, getAmountToCollectToday, isLoanCompleted, isLoanDueToday, isLoanExpired, isLoanOutstanding } from "../Helpers";
import { getInlineLoader } from "../Helpers";
import { MdPerson, MdSubject } from "react-icons/md";
import logo from '../assets/logo.png';

export default function View() {
  const appContext = useContext(AppContext);

  const [ready, setReady] = useState(false);

  

  async function init() {
    setReady(false);
    await Promise.all([
      //appContext.getDashboardCounts(),
    ])
    setReady(true);
  }

  
  useEffect(() => {
    init();
  }, []);

  

  

  if (ready && appContext.currentUserData) {
    return (
      <div
        className="container"
      >
        <div className="row">
          
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  
                  
                  <div className="col-md-12">
                    <h6 
                      className="font-light"
                      style={{
                        fontSize: "32px"
                      }}
                    >
                      Welcome Back, {appContext.currentUserData.fullname}
                    </h6>
                  </div>

                  <div className="col-md-12 mt-4 mb-4">
                    <div className="row">
                      
                      <div className="col-md-4">
                        <img
                          src={logo}
                          style={{
                            width: "100%",
                          }}
                        />
                      </div>
                      <div className="col-md-8">
                        <h6
                          className="font-bold"
                          style={{
                            fontSize: "32px",
                            textTransform: "uppercase",
                          }}
                        >
                          NANGUBA HOSPITAL
                        </h6>
                        <h6
                          className="text-muted"
                          style={{
                            fontSize: "24px"
                          }}
                        >
                          Dodoma, Tanzania.
                        </h6>
                        <h6
                          className="text-muted"
                          style={{
                            fontSize: "18px"
                          }}
                        >
                          Role: <span className="font-bold" >{appContext.currentUserData.role}</span>
                        </h6>
                        
                      </div>
                      
                    </div>
                  </div>
                  


                  <div className="col-12 col-md-6">
                    <div
                      className="card"
                      style={{
                        cursor: "pointer"
                      }}
                      onClick={() => {
                        appContext.navTo({
                          item: 'my_profile',
                        })
                      }}
                    >
                      <div className="card-body">
                        <h6
                          className="card-title"
                        >
                          My Profile
                        </h6>

                        <h6
                          className="text-end"
                        >
                          <MdPerson className="text-secondary" size={42}/>
                        </h6>								
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-6">
                    <div
                      className="card"
                      style={{
                        cursor: "pointer"
                      }}
                      onClick={() => {
                        appContext.navTo({
                          item: 'my_shifts',
                        })
                      }}
                    >
                      <div className="card-body">
                        <h6
                          className="card-title"
                        >
                          My Shifts
                        </h6>

                        <h6
                          className="text-end"
                        >
                          <MdSubject  className="text-secondary" size={42}/>
                        </h6>									
                      </div>
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
          </div>


          <div className="col-12 col-md-6">
            <div
              className="card"
              style={{
                cursor: "pointer"
              }}
              onClick={() => {
                appContext.navTo({
                  item: 'patients',
                })
              }}
            >
              <div className="card-body">
                <h6
                  className="card-title"
                >
                  Patients
                </h6>

                <h6
                  className="text-end"
                  style={{
                    fontSize: "42px"
                  }}
                >
                  0
                </h6>								
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div
              className="card"
              style={{
                cursor: "pointer"
              }}
              onClick={() => {
                appContext.navTo({
                  item: 'visitations',
                })
              }}
            >
              <div className="card-body">
                <h6
                  className="card-title"
                >
                  Visitations
                </h6>

                <h6
                  className="text-end"
                  style={{
                    fontSize: "42px"
                  }}
                >
                  0
                </h6>								
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div
              className="card"
              style={{
                cursor: "pointer"
              }}
              onClick={() => {
                appContext.navTo({
                  item: 'rooms',
                })
              }}
            >
              <div className="card-body">
                <h6
                  className="card-title"
                >
                  Rooms
                </h6>

                <h6
                  className="text-end"
                  style={{
                    fontSize: "42px"
                  }}
                >
                  0
                </h6>								
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div
              className="card"
              style={{
                cursor: "pointer"
              }}
              onClick={() => {
                appContext.navTo({
                  item: 'staff',
                })
              }}
            >
              <div className="card-body">
                <h6
                  className="card-title"
                >
                  Staff
                </h6>

                <h6
                  className="text-end"
                  style={{
                    fontSize: "42px"
                  }}
                >
                  0
                </h6>								
              </div>
            </div>
          </div>


        </div>

      </div>
    )
  } else {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }
}
